import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import BlogDetailsHero from "./BlogDetailsHero";
import BlogDetailsPage from "./BlogDetailsPage";
import AppInstall from "./AppInstall";
import Footer from "./Footer";
import UserConsent from "./UserConsent";

function BlogInner() {
  const { id } = useParams();
  const [listData, setListData] = useState({});

  useEffect(() => {
    let apiUrl = `https://rapi.ifood.tv/blogs.php?searchType=blogdetail&appId=9&siteId=236&deviceId=&auth-token=1217575&version=6.0&id=${id}`;
    //`https://rapi.ifood.tv/blogs.php?searchType=blogdetail&appId=9&siteId=236&deviceId=&auth-token=1217575&version=9.0&id=4`;
    /*const fetchBlogDetails = async () => {
      try {
        const apiRes = await fetch(apiUrl).then((res) => res.json());
        if (
          apiRes.status === "ok" &&
          apiRes.results &&
          apiRes.results.length > 0
        ) {
          setListData(apiRes.results[0]);
        } else {
          //console.warn("API failed or no data, loading local JSON...");
          fetchLocalData();
        }
      } catch (error) {
        //console.error("Error fetching API, loading local JSON...", error);
        fetchLocalData();
      }
    };*/

    const fetchLocalData = async () => {
      try {
        const localRes = await fetch(
          `./assets/data/blogs.json?r=${Date.now()}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        ).then((res) => res.json());

        const getDetails = localRes.find((val) => val.id == id);
        if (getDetails) {
          setListData(getDetails);
        }
      } catch (error) {
        console.error("Error loading local JSON data", error);
      }
    };

    fetchLocalData();
    //fetchBlogDetails();
  }, [id]);

  return (
    <>
      <AppInstall />
      {listData && listData.id && <BlogDetailsHero data={listData} />}
      {listData && listData.id && <BlogDetailsPage data={listData} />}
      <Footer />
      <UserConsent />
    </>
  );
}

export default BlogInner;
